import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import downloadService from '@/app/service/util/download'
import { getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'
import { FileType } from '@/app/types'

export const useDownloadFile = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [isLoading, setLoading] = useState(false)

  const download = useCallback(
    async (filename: string, downloadImmediate = false) => {
      if (!orgId || !filename?.trim() || isLoading) {
        return undefined
      }

      setLoading(true)
      try {
        const blob = await downloadService.files(orgId, filename, downloadImmediate)
        const url = URL.createObjectURL(blob)
        const fileObj: FileType = { filename, title: filename, url }
        return fileObj
      } catch (err) {
        const message = getErrorMessage(err, 'Failed to download file')
        dispatch(
          createNotification({
            'download-file-error': {
              type: 'error',
              message,
            },
          }),
        )
        return undefined
      } finally {
        setLoading(false)
      }
    },
    [isLoading, orgId, dispatch],
  )

  return [download, { isLoading }] as const
}
